// import { BrightCoveVideo } from "../objects/BrightCoveVideo";
// // import { VideoJSPlayer } from "../objects/VideoJSPlayer";
// import { VimeoVideo } from "../objects/VimeoVideo";
// import { WistiaVideo } from "../objects/WistiaVideo";
// import { YouTubeVideo } from "../objects/YouTubeVideo";
interface VideoPlayer {
  appendPlayerTo(where: JQuery): void;
  mDiv: JQuery<HTMLElement>;
  videoId: string | number;
  useIframe?: boolean;
  destroy(): void;
  embed(): void;
  pause(): void;
  play(): void;
  playFromBeginning(): void;
  getCurrentTime(): Promise<number>;
  snapToLive(time: moment.Moment, ignorePaused: boolean): void;
  resumeVideo(): void;
  onTimeChange?(): void;
  getDurationInMilliseconds(): number;
  onWatchedSome(): void;
  onWatchedHalf(): void;
  onWatched(): void;
  onWatchedFully(): void;
  onTransitionOut(): void;
  mute(aBool?: boolean): void;
  videoIsLive?(): boolean;
}

export default class StreamVideoPlayer {
  mDiv: JQuery<HTMLElement>;
  mContent: JunoContent;
  mVideoPlayer!: VideoPlayer;

  private _constructorParams: any;
  private _videoId: number;
  private _videoUrl: string;
  private _clickText: string;
  private _contentType: string;
  private _controls: boolean;
  private _clickText: string;
  private _preLoad: string;
  private _start: boolean;
  private _useIframe: boolean;
  private _fillMode: CrowdHub_App.CONFIG.PRERROLL_FILLMODE | CrowdHub_App.CONFIG.VIDEOSTREAM_FILLMODE;
  private _onPause: Function = () => {};
  private _onWatchedSome: Function = () => {};
  private _onWatchedHalf: Function = () => {};
  private _onWatched: Function = () => {};
  private _onTimeChanged: Function = () => {};
  private _onWatchedFully: Function = () => {};
  private _videoPlayerClass:
    | typeof BrightCoveVideo
    | typeof WistiaVideo
    | typeof YouTubeVideo
    | typeof VideoJSPlayer
    | typeof VimeoVideo
    | typeof AmazonIVSPlayer
    | null = null;

  constructor(aConstructorParams: any) {
    this._constructorParams = aConstructorParams;
    this.mContent = aConstructorParams.content;
    this._clickText = aConstructorParams.clickText;
    this._contentType = aConstructorParams.contentType;
    this._controls = aConstructorParams.controls;
    this._fillMode = aConstructorParams.fillMode;
    this._onPause = aConstructorParams.onPause;
    this._onTimeChanged = aConstructorParams.onTimeChanged;
    this._onWatched = aConstructorParams.onWatched;
    this._onWatchedFully = aConstructorParams.onWatchedFully;
    this._onWatchedHalf = aConstructorParams.onWatchedHalf;
    this._onWatchedSome = aConstructorParams.onWatchedSome;
    this._preLoad = aConstructorParams.preLoad;
    this._start = aConstructorParams.start;
    this._videoId = aConstructorParams.videoId;
    this._videoUrl = aConstructorParams.videoUrl;
    this._useIframe = aConstructorParams.useIframe || false;
    this._videoPlayerClass = aConstructorParams.videoPlayerClass;

    this.createVideoPlayer();
  }

  destroy(): void {
    this.mVideoPlayer.destroy();
    this.mDiv.clear();
  }

  createVideoPlayer(): void {
    // now create the appropriate video player that uses IVideoPlayer interface
    if (this._videoPlayerClass != null) {
      this.mVideoPlayer = new this._videoPlayerClass({
        autoPlay: this._shouldAutoPlay(),
        content: this.mContent,
        clickText: this._clickText,
        contentType: this._contentType,
        controls: this._controls,
        fillMode: this._fillMode,
        useIframe: this._useIframe,
        id: this._videoId,
        preLoad: this._preLoad,
        onPause: this._onPause,
        onWatchedSome: this._onWatchedSome,
        onWatchedHalf: this._onWatchedHalf,
        onWatched: this._onWatched,
        onTimeChanged: this._onTimeChanged,
        onWatchedFully: this._onWatchedFully,
        start: this._start,
        url: this._videoUrl,
      });

      if (
        (App.INSTANCE.CurrentUser.IsLoggedIn() == false || this.mContent.hasAccess() == false) &&
        !this.mContent.ContainsTagName('allow video preview')
      ) {
        this._showVideoPreviewCover();
      }
    }
  }

  private _shouldAutoPlay(): boolean {
    if (
      App.INSTANCE.CurrentUser.IsLoggedIn() == false ||
      this.mContent.ContainsTagName(CrowdHub_App.TAGNAME_PREVENTAUTOPLAY) ||
      this._constructorParams.autoPlay == false
    ) {
      return false;
    }
    return true;
  }

  private _showVideoPreviewCover(): void {
    let struct = {
      style: 'video_preview_cover',
      children: [
        {
          style: 'video_preview_cover_icon',
          interior: HGEN.faicon({
            style: CrowdHub_App.CONFIG.ICON_PREVIEW_VIDEO_LOCK,
          }),
        },
        {
          style: 'video_preview_cover_title',
          interior: CrowdHub_App.LANG.PREVIEW_VIDEO_TITLE,
        },
        {
          style: 'video_preview_cover_message',
          if: !App.INSTANCE.CurrentUser.IsLoggedIn(),
          interior: CrowdHub_App.LANG.PREVIEW_VIDEO_MESSAGE,
        },
        {
          style: 'video_preview_cover_message',
          if: App.INSTANCE.CurrentUser.IsLoggedIn(),
          interior: CrowdHub_App.LANG.PREVIEW_VIDEO_REGISTER_MESSAGE,
        },
        { style: 'video_preview_cover_buttons' },
      ],
    };
    this.mVideoPlayer.mDiv.append($(HGEN.tree(struct)));
    let aButton = new BaseCSSButton();
    aButton.initialize({
      id: 'preview_vid' + moment(),
      textStyle: '',
      buttonStyle: 'mini_button_outline margin_bottom_big',
      text: App.INSTANCE.CurrentUser.IsLoggedIn()
        ? CrowdHub_App.LANG.PREVIEW_VIDEO_MUSTREGISTER
        : CrowdHub_App.LANG.PREVIEW_VIDEO_PRIMARYACTION,
      click: (btnScope, scope, event) => {
        // dont want to be able to click thru the register/login button and play the video behind
        event.stopPropagation();
        if (App.INSTANCE.CurrentUser.IsLoggedIn()) {
          App.INSTANCE.checkAccessLevel(this.mContent);
        } else {
          App.INSTANCE.loginOrCreate({
            forceLogin: CrowdHub_App.CONFIG.REQUIRE_GLOBAL_LOGIN,
            aMessage: CrowdHub_App.LANG.LOGINREASON_PREVIEWVIDEO,
            aOnComplete: () => {},
          });
        }
      },
      scope: this,
      showLoader: false,
      container: this.mVideoPlayer.mDiv.find('.video_preview_cover_buttons'),
    });
  }
}
